import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "排行榜", to: "/#rank" },
  { label: "完本推荐", to: "/#wanben" },
  { label: "关于我们", to: "/about" },
  { label: "常见问题", to: "/faq" },
  { label: "联系我们", to: "/contact" },
];

export default function Footer() {
  return (
    <footer className="mt-auto border-t border-background-800 bg-background-900">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-primary-500 to-accent-600 text-background-950">
                <i className="ri-fire-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                虚空<span className="text-gradient-gold">漫画</span>
              </span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-6 text-foreground-500">
              聚合海量异世界、穿越、奇幻、脑洞、玄幻题材漫画，每日更新热门榜单与完本推荐，为每一个书荒的你找到下一部入坑作。
            </p>
            <div className="mt-5 flex gap-3">
              <a href="#contact" aria-label="联系" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg bg-background-800 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-950">
                <i className="ri-mail-line" />
              </a>
              <a href="#contact" aria-label="公众号" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg bg-background-800 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-950">
                <i className="ri-wechat-line" />
              </a>
              <a href="#contact" aria-label="微博" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg bg-background-800 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-950">
                <i className="ri-weibo-line" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wide text-foreground-950">快速导航</h4>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="cursor-pointer text-sm text-foreground-500 transition-colors hover:text-primary-400">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wide text-foreground-950">漫画分类</h4>
            <ul className="mt-4 space-y-3">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="cursor-pointer text-sm text-foreground-500 transition-colors hover:text-primary-400">
                    {c.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wide text-foreground-950">追更订阅</h4>
            <p className="mt-4 text-sm leading-6 text-foreground-500">
              订阅站内动态，第一时间获取最新更新与热门榜单变化。
            </p>
            <form className="mt-4 flex flex-col gap-2">
              <input
                type="email"
                name="email"
                required
                placeholder="输入邮箱地址"
                aria-label="邮箱"
                className="w-full rounded-lg border border-background-700 bg-background-950 px-4 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-500 focus:border-primary-500 focus:outline-none"
              />
              <button
                type="submit"
                className="cursor-pointer whitespace-nowrap rounded-lg bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-950 transition-colors hover:bg-primary-600"
              >
                订阅更新
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 sm:flex-row md:px-6">
          <p className="text-xs text-foreground-500">© 2026 虚空漫画网 · 用心整理每一部入坑作</p>
          <p className="text-xs text-foreground-600">异世界 · 穿越 · 奇幻 · 脑洞 · 玄幻</p>
        </div>
      </div>
    </footer>
  );
}